import { atomWithBroadcast } from '../core';

export const mifidMessageAtom = atomWithBroadcast<string>('mifid/message', '');
